import { SubscriptionComponent } from '../../../../../shared/helpers/subscription.component';
import { Component, OnInit, ViewChild, inject, ChangeDetectionStrategy } from '@angular/core';
import { WorkplaceTableStore } from './workplace-table.store';
import { ActivatedRoute, Router } from '@angular/router';
import { WorkplaceGridItemObject } from '@it2go/types';
import { contentGlobalSuccess } from '../../../../content.error';
import { ConfirmBuilder } from '../../../../../shared/service/confirm.builder';
import { CardTableComponent } from '../../../../../shared/components/kit/table/card-table.component';
import { AsyncPipe } from '@angular/common';
import { PrimeTemplate } from '@openng/optimus-ui/api';
import { MapLinkTagComponent } from '../../../../../../components/kit/map-link-tag/map-link-tag.component';
import { userChipField } from '../../../../../shared/components/kit/table/table.fields';
import { TableColumn } from '../../../../../shared/components/kit/table/table.types';
import { UserChipRenderTypeEnum } from '../../../../../../components/kit/user-chip/user-chip.component.types';

@Component({
    selector: 'app-workplace-table',
    templateUrl: 'workplace-table.component.html',
    styleUrl: 'workplace-table.component.scss',
    providers: [WorkplaceTableStore],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        AsyncPipe,
        CardTableComponent,
        PrimeTemplate,
        MapLinkTagComponent,
    ],
})
export class WorkplaceTableComponent extends SubscriptionComponent implements OnInit {
    protected readonly store = inject(WorkplaceTableStore);
    private readonly router = inject(Router);
    private readonly route = inject(ActivatedRoute);
    private readonly confirmBuilder = inject(ConfirmBuilder);


    @ViewChild(CardTableComponent) table!: CardTableComponent;

    public ngOnInit(): void {
        this.subs.push(
            this.store.apiSuccess.deleteWorkplace.subscribe(async () => {
                    contentGlobalSuccess.next('workplace.message.deleted');
                    await this.table.reload();
                },
            ),
        );
    }

    protected async goToDetail(item: WorkplaceGridItemObject | null = null): Promise<void> {
        const id = item?.id || 'create';

        const workplacesGrid = await this.store.data.workplaces$.promise();
        const state = {
            numberOfWorkplaces: workplacesGrid?.paging.total ?? 0,
        };

        await this.router.navigate([`../workplaces/${id}`], { relativeTo: this.route, state });
    }

    protected async delete(item: any): Promise<void> {
        this.confirmBuilder.confirm(
            'workplace.message.deleteTitle',
            'workplace.message.deleteMessage',
            () => {
                this.store.api.deleteWorkplace({ id: item.item.id });
            },
            { name: item.name },
            'pi-trash',
            item.event.target,
        );
    }

    protected readonly columns: TableColumn[] = [
        { name: 'name', sortable: true },
        { name: 'address' },
        userChipField('person', UserChipRenderTypeEnum.User, { dataKey: 'responsiblePerson.user' }),
    ];

}
